import DefaultDoubleSidePage from "@Front/Components/LayoutTemplates/DefaultDoubleSidePage";
import classes from "./classes.module.scss";
import backgroundImage from "@Assets/images/background_refonte.svg";
import { useRouter } from "next/router";
import { useLoginController, LoginStep } from "./hooks/useLoginController";
import { ErrorAlert } from "@Front/Components/DesignSystem/ErrorAlert";
import { useSiteTextContent } from "@Front/Stores/SiteTextsContext";
import { useLoginErrorParamToaster } from "./hooks/useLoginErrorParamToaster";
import { LoginStepPanels } from "./components/LoginStepPanels";
import { useLoginPageLoadLog } from "./hooks/useLoginPageLoadLog";
import { LoginSsoOAuthRedirectOnly } from "./LoginSsoOAuthRedirectOnly";
import { useLoginRouterScope } from "./hooks/useLoginRouterScope";
import { routerHasCustomerLoginInvitationScope } from "./helpers/customerLoginRouterScope";
import { isPublicSiteEnsoLine } from "@Front/Utils/publicSiteBranding";

export { LoginStep };

export default function Login(): React.JSX.Element {
	const router = useRouter();
	const controller = useLoginController();
	const loginErrorTitle = useSiteTextContent("login.errorTitle");
	const loginErrorMessage = useLoginErrorParamToaster(router, loginErrorTitle);
	const loginScope = useLoginRouterScope(router);

	useLoginPageLoadLog(router, controller.step);

	if (isPublicSiteEnsoLine() && !routerHasCustomerLoginInvitationScope(loginScope)) {
		return <LoginSsoOAuthRedirectOnly />;
	}

	return (
		<DefaultDoubleSidePage title={"Login"} image={backgroundImage}>
			<div className={classes["root"]}>
				{loginErrorMessage && (
					<div role="alert" aria-live="polite" className={classes["error-banner"]}>
						<ErrorAlert error={loginErrorMessage} title={loginErrorTitle} variant="default" />
					</div>
				)}
				<LoginStepPanels controller={controller} />
			</div>
		</DefaultDoubleSidePage>
	);
}
